import {
	LaravelResponse,
	PagedMultiSelectField,
	PagedSingleSelectField,
	PagedSingleSelectFieldProps,
	laravelSelectFetchConfig,
} from "@dgs/core";
import { FC } from "react";
import { distributionListService } from "../shared/api/distributionListService";
import { IDistributionListOption } from "../shared/types";

const fetchConfig = laravelSelectFetchConfig(distributionListService.optionsKey, (search, page) =>
	distributionListService.options(search, page).then((x) => x.data),
);
interface Props {
	name: string;
	label: string;
	disabled?: boolean;
	required?: boolean;
}
export const DistributionListSelectField: FC<
	Props & {
		onChange?: PagedSingleSelectFieldProps<
			IDistributionListOption,
			LaravelResponse<IDistributionListOption>
		>["onChange"];
	}
> = (props) => {
	return <PagedSingleSelectField {...props} fetchConfig={fetchConfig} />;
};

export const DistributionListMultiSelectField: FC<Props> = (props) => {
	return <PagedMultiSelectField {...props} fetchConfig={fetchConfig} />;
};
